export const UPDATE_PAGE_DATA = "KPI_ASK_DETAILS_UPDATE_PAGE_DATA";
